{
    "Accessibility menu": "Menú de accesibilidade",
    "Close": "Pechar",
    "Text and Reading": "Texto e lectura",
    "Navigation and Interaction": "Navegación e interacción",
    "Text Align": "Aliñamento do Texto",
    "Align Left": "Aliñar á Esquerda",
    "Align Center": "Centrar",
    "Align Right": "Aliñar á Dereita",
    "Adjust Font Size": "Axustar o Tamaño da Fonte",
    "Highlight Title": "Destacar Título",
    "Highlight Links": "Destacar Ligazóns",
    "Readable Font": "Fonte Lexible",
    "Color and Contrast": "Cor e contraste",
    "Dark Contrast": "Contraste Escuro",
    "Light Contrast": "Contraste Claro",
    "High Contrast": "Alto Contraste",
    "High Saturation": "Alta Saturación",
    "Low Saturation": "Baixa Saturación",
    "Monochrome": "Monocromo",
    "Tools": "Ferramentas",
    "Reading Guide": "Guía de Lectura",
    "Big Cursor": "Cursor Grande",
    "Increase Font Size": "Aumentar o Tamaño da Fonte",
    "Decrease Font Size": "Diminuír o Tamaño da Fonte",
    "Letter Spacing": "Espazamento entre Letras",
    "Line Height": "Altura da Liña",
    "Font Weight": "Grosor da Fonte",
    "Dyslexia Font": "Fonte para a Dislexia",
    "Language": "Idioma",
    "Accessibility widget": "Abrir o menú de accesibilidade",
    "Accessibility Profiles": "Perfís de Accesibilidade",
    "Cognitive Disability": "Discapacidade Cognitiva",
    "Seizure Safe": "Protección Contra Crises Epilépticas",
    "Accessibility statement": "Declaración de accesibilidade",
    "ADHD": "TDAH",
    "Low Vision": "Baixa Visión",
    "Pause Animations": "Pausar Animacións",
    "Animation paused": "Animación en pausa",
    "Reset all settings": "Restablecer todos os axustes",
    "Shortcut:": "Atallo:",
    "Epilepsy Safe Mode": "Modo de Protección Contra Crises Epilépticas",
    "Mute sounds": "Silenciar sons",
    "Page read": "Lectura da páxina",
    "Page read controls": "Controis de lectura da páxina",
    "Pause": "Pausar",
    "Resume": "Retomar",
    "Stop": "Deter",
    "Settings": "Axustes",
    "Speed": "Velocidade",
    "Voice": "Voz",
    "Close accessibility menu": "Pechar o menú de accesibilidade",
    "Back to accessibility menu": "Volver ao menú de accesibilidade",
    "Search languages": "Buscar idiomas",
    "Selected language": "Idioma seleccionado",
    "View accessibility statement (opens in new window)": "Ver a declaración de accesibilidade (ábrese nunha nova xanela)",
    "Visit CookieYes website (opens in new window)": "Visitar o sitio web de CookieYes (ábrese nunha nova xanela)",
    "Reset all accessibility settings to default": "Restablecer todos os axustes de accesibilidade aos valores predeterminados"
}
